<app-full-app-component *ngIf="fullApp"></app-full-app-component>
<app-single-app-component *ngIf="!fullApp" [singleApp]="singleModule"></app-single-app-component>